// utils/constants/authConfigsList.ts
import { AuthConfig, AuthFlow } from '../../types';


export const authConfigsList: Record<AuthFlow, AuthConfig> = {
	b2c: {
		clientId: process.env.REACT_APP_IDPROVIDER_CLIENT_ID || "",
		policy:  process.env.REACT_APP_POLICY_B2C || "",
		scope: "openid profile offline_access"
	},
	b2b: {
		clientId: process.env.REACT_APP_IDPROVIDER_CLIENT_ID || "",
		policy: process.env.REACT_APP_POLICY_B2B || "",
		scope: "openid profile offline_access"
	}
};
